import axios from 'axios'
export default{
  state:{
    reservas: [],
    suscripciones: []
  },
  getters:{
    reservas(state){
      return state.reservas
    },
    suscripciones(state){
      return state.suscripciones
    }
  },
  mutations:{  
    get_reservas(state, reservas) {
      if(typeof reservas.length !== 'undefined'){
        state.reservas.splice(0)
        reservas.forEach(h => {
          state.reservas.push(h)
        })
      }
      return state.reservas
    },
    get_suscripciones(state, suscripciones) {
      if(typeof suscripciones.length !== 'undefined'){
        state.suscripciones.splice(0)
        suscripciones.forEach(h => {
          if(h.reserva_nodo)
            state.suscripciones.push(h)
        })
      }
      return state.reservas
    },
    eliminar_reserva(state, datos){
      state.reservas.forEach( (reserva,index) => {
        if(reserva.id == datos.reserva_id)
          state.reservas.splice(index,1)
      })
    }
  },
  actions:{
    get_reservas(context) {
      axios.defaults.baseURL = process.env.VUE_APP_API_URL
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.getters['auth/token']
      if (context.getters['auth/loggedIn']) {
        return new Promise((resolve, reject) => {
          axios.get('/reserva')
            .then(response => {
              if(response.data.success){
                context.commit('get_reservas',response.data.reservas);
                context.commit('get_suscripciones',response.data.suscripciones.filter(suscripcion => suscripcion.nodo != null));
                resolve(response.data.reservas)
              }else{
                reject(response.data.message)
              }
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
    eliminar_reserva(context, datos) {
      axios.defaults.baseURL = process.env.VUE_APP_API_URL
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.getters['auth/token']
      if (context.getters['auth/loggedIn']) {
        axios.delete('/reserva/api_destroy/' + datos.reserva_id)
        .then(response => {
          response
          context.commit('eliminar_reserva',{reserva_id : datos.reserva_id})
        })
      }

    },
    unsubscribe(context, datos){
      axios.defaults.baseURL = process.env.VUE_APP_API_URL
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.getters['auth/token']
      if (context.getters['auth/loggedIn']) {
        axios.delete('/subscription/unsubscribe/' + datos.subscription_id)
        .then(response => {
          response
          context.dispatch('get_reservas');
        })
      }
    },
  }
}